import { getRequestConfig } from '../auth/auth';
import { ApiGateway } from '../config/config';
import axios from 'axios';
import { fetchWithCallbacks } from '../utils/inflightCallbacks';

export const loadOwnership = async (ownershipUuid, requestConfig) => {
  if ( !requestConfig ) {
    requestConfig = await getRequestConfig()
  }

  const basePath = `${ApiGateway.ownership}/search`
  const search = { uuid: ownershipUuid, searchIncludes: ['manufacturer'] }
  const response = await axios.post(basePath, search, requestConfig)
  if (response.data) {
    const { results } = response.data
    return results[0]
  }
}

export const saveOwnership = async (ownershipUuid, ownershipDetail, requestConfig) => {
  if ( !requestConfig ) {
    requestConfig = await getRequestConfig()
  }

  const basePath = `${ApiGateway.facilityManagement}/ownership${ownershipUuid ? '/' + ownershipUuid : ''}`
  const payload = { ...ownershipDetail }
  const response = await axios.put(basePath, payload, requestConfig)
  if (response.data) {
    const { status, instance, created } = response.data
    return response.data
  }
}

const cleanOwnershipSearch = (search = {}) => {
  const cleaned = { ...search }
  if (cleaned.isActive !== undefined) {
    const activeTokens = [true, 'true', 1, '1']
    const inactiveTokens = [false, 'false', 0, '0']
    if (activeTokens.includes(cleaned.isActive)) {
      cleaned.isActive = '1'
    } else if (inactiveTokens.includes(cleaned.isActive)) {
      cleaned.isActive = '0'
    }
  }
  return cleaned
}

export const searchOwnerships = async (search) => {
  const requestConfig = await getRequestConfig()
  const basePath = `${ApiGateway.ownership}/search`

  const response = await axios.post(basePath, cleanOwnershipSearch(search), requestConfig)
  if (response.data) {
    const result = response.data
    return result
  }
}

export const searchExtendedAttributeValues  = async (entityType, entityId) => {
  const requestConfig = await getRequestConfig()
  const basePath = `${ApiGateway.attribute}/values/${entityType}/${entityId}/`
  const key = basePath

  const requestFn = async () => {
    const response = await axios.get(basePath, requestConfig)
    return response.data
  }

  return fetchWithCallbacks(key, requestFn)
}

export const getOwnershipList = async (search) => {
  const requestConfig = await getRequestConfig()
  const basePath = `${ApiGateway.ownership}/search`

  const response = await axios.post(basePath, cleanOwnershipSearch(search), requestConfig)
  if (response.data) {
    const { results } = response.data
    return results
  }
}